import axios from "axios";

const NOCOBASE_API_URL = "https://app.poolcrm.ru/api";

const storiesClient = axios.create({
  baseURL: NOCOBASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Authorization": import.meta.env.VITE_AUTHORISATION_CLUB_INFO,
  },
});

export interface NocoBaseAttachment {
  id: number;
  url: string;
  preview?: string;
  filename: string;
}

export interface NocoBaseStoryGroup {
  id: number;
  name: string;
  avatar: NocoBaseAttachment[];
  is_active?: boolean;
  allowed_phones?: string;
  sort?: number;
  branch_id?: string;
}

export interface NocoBaseStory {
  id: number;
  title: string;
  description: string;
  duration: number;
  is_active: boolean;
  link: string;
  link_text: string;
  media: NocoBaseAttachment[];
  story_group: NocoBaseStoryGroup;
  sort?: number;
  branch_id?: string;
}

interface StoriesListResponse {
  data: NocoBaseStory[];
  meta: {
    count: number;
    page: number;
    pageSize: number;
    totalPage: number;
  };
}

export async function getStories(branchId1c?: string): Promise<NocoBaseStory[]> {
  const filter: Record<string, unknown> = { is_active: true };
  if (branchId1c) {
    // Показываем сторис привязанные к филиалу (по id_1c) ИЛИ без привязки к филиалам
    filter["$or"] = [{ "branches.id_1c": branchId1c }, { "branches.id": null }];
  }
  const response = await storiesClient.get<StoriesListResponse>(
    `/stories:list?filter=${encodeURIComponent(JSON.stringify(filter))}&appends=media,story_group,story_group.avatar&sort=order`
  );
  return response.data.data;
}
